document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector(".mySwiper-icons")) {
    var swiper = new Swiper(".mySwiper-icons", {
      slidesPerView: 3,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      breakpoints: {
        654: { slidesPerView: 4 },
        908.5: { slidesPerView: 6 }
      }
    });
  }


  // Pesquisa
  const search = document.getElementById("searchPainel");
  const buttonSearch = document.getElementById("myButton");
  const searchInput = document.getElementById("search-input");
  const close = document.getElementById("buttonClose");
  const searchContent = document.getElementById("search-content");

  // Carrinho
  const iconCart = document.getElementById("cartIcon");
  const painelCart = document.getElementById("painelCart");
  const closeBtn = document.getElementById("closeCart");

  // Login
  const abrirLoginPainelBtn = document.getElementById('abrirLoginPainel');
  const loginPainel = document.getElementById('loginPainel');
  const btnFecharLoginPainel = document.getElementById("fecharLoginPainel");
  const abrirLoginMobileBtn = document.getElementById('abrirLoginMobile');

  // Menu Mobile
  const buttonHamburguer = document.getElementById('button-hamburguer');
  const menuMobile = document.getElementById('menuMobile');
  const closeMobileBtn = document.getElementById('closeMobile');

  // Categorias
  const btnCategory = document.getElementById('btnCategory');
  const menuCategorias = document.getElementById('menu-categorias');
  const closeCategoryBtn = document.getElementById('close-btn');

  // Cart
  if (iconCart && painelCart) {
    iconCart.addEventListener("click", function() {
      iconCart.classList.add("clicado");
      painelCart.classList.add("open");
    });
  }

  if (closeBtn && painelCart) {
    closeBtn.addEventListener("click", function() {
      painelCart.classList.remove("open");
      if (iconCart) iconCart.classList.remove("clicado");
    });
  }

  // Search
  if (buttonSearch && search) {
    buttonSearch.addEventListener("click", function() {
      search.style.display = "flex";
      if (searchContent) searchContent.style.display = "none";
      if (searchInput) searchInput.focus();
    });
  }

  if (close && search) {
    close.addEventListener("click", function() {
      search.style.display = "none";
      if (searchContent) searchContent.style.display = "flex";
    });
  }

  // Login
  function toggleLoginPanel() {
    if (loginPainel) loginPainel.classList.toggle('open');
  }

  if (abrirLoginPainelBtn) {
    abrirLoginPainelBtn.addEventListener('click', function(event) {
      event.preventDefault();
      toggleLoginPanel();
    });
  }

  if (abrirLoginMobileBtn) {
    abrirLoginMobileBtn.addEventListener('click', function(event) {
      event.preventDefault();
      toggleLoginPanel();
    });
  }

  if (btnFecharLoginPainel) {
    btnFecharLoginPainel.addEventListener('click', function() {
      loginPainel.classList.remove('open');
    });
  }

  // Menu Mobile
  if (buttonHamburguer && menuMobile) {
    buttonHamburguer.addEventListener('click', function() {
      menuMobile.classList.toggle('open');
      buttonHamburguer.classList.toggle('clicado');
    });
  }

  if (closeMobileBtn) {
    closeMobileBtn.addEventListener('click', function() {
      menuMobile.classList.remove('open');
      if (buttonHamburguer) buttonHamburguer.classList.remove('clicado');
    });
  }

  // Categorias
  if (btnCategory && menuCategorias) {
    btnCategory.addEventListener('click', function() {
      menuCategorias.classList.toggle('open');
    });
  }

  if (closeCategoryBtn) {
    closeCategoryBtn.addEventListener('click', function() {
      menuCategorias.classList.remove('open');
    });
  }

  // Painéis ao Clicar Fora
  document.addEventListener('click', function(event) {
    // Fechar Login
    if (loginPainel && loginPainel.classList.contains('open')) {
      if (!loginPainel.contains(event.target) &&
        (!abrirLoginPainelBtn || !abrirLoginPainelBtn.contains(event.target)) &&
        (!abrirLoginMobileBtn || !abrirLoginMobileBtn.contains(event.target))) {
        loginPainel.classList.remove('open');
      }
    }

    // Fechar Menu Mobile
    if (menuMobile && menuMobile.classList.contains('open')) {
      if (!menuMobile.contains(event.target) &&
        (!buttonHamburguer || !buttonHamburguer.contains(event.target))) {
        menuMobile.classList.remove('open');
        if (buttonHamburguer) buttonHamburguer.classList.remove('clicado');
      }
    }

    // Fechar Categorias
    if (menuCategorias && menuCategorias.classList.contains('open')) {
      if (!menuCategorias.contains(event.target) &&
        (!btnCategory || !btnCategory.contains(event.target))) {
        menuCategorias.classList.remove('open');
      }
    }
  });

});
